import { documentAutomation } from "@smart/bridge-images-dom";
import {
  Card,
  FailureMessage,
  Illustrations,
} from "@smart/itops-sb-design-system-dom";

import { AutoFillStatus } from "../../types";

type AutoFillIndicatorProps = {
  status: AutoFillStatus | undefined;
  loading?: boolean;
};

export const AutofillIndicator = ({
  status,
  loading,
}: AutoFillIndicatorProps) => {
  if (status !== "filling" && status !== "failed" && !loading) {
    return null;
  }

  return (
    <div className="relative z-[85] w-full flex justify-center my-4 text-ui">
      <Card
        size="readable"
        flow="row"
        align="center"
        loading={status === "filling" || loading}
        className="border-b-0"
      >
        <Illustrations illustrations={[documentAutomation]} active={0} />
        <div>
          <h2 className="my-[1.6rem] text-h4 font-bold">
            Autofill in progress
          </h2>
          <div>
            Once complete, review all fields carefully and make any necessary
            edits.
          </div>
          {status === "failed" && (
            <FailureMessage
              action="auto filling form"
              textOverride="Something went wrong. Please try again."
              className="mt-[0.8rem]"
            />
          )}
        </div>
      </Card>
    </div>
  );
};
